import { handleImgSize } from '@/common/utils/map_view_data'

function checkPlanarGraph (item) {
    return false
    // var activities = item ? item.activities : []
    // return activities && activities.length && activities.indexOf('planar_graph') > -1
}

function checkShowVr (item) {
    return false
    // var vr_resource = item ? item.vr_resource : {}
    // return vr_resource && vr_resource.vr_photo_url
}

function formatSuffix (url) {
    return handleImgSize(url, 210, 140, {})
}

function getHeadimg (item) {
    return formatSuffix(item ? item.cover_photo_url : '')
}


export default {
    methods: {
        checkPlanarGraph: checkPlanarGraph,
        checkShowVr: checkShowVr,
        getHeadimg: getHeadimg
    }
}